import React from 'react';

const Icon = ({ width = '33', height = '32', fill = 'white', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 33 32" fill="none" {...other}>
            <rect x="4.839" y="4.339" width="23.14" height="23.14" rx="2.778" stroke={fill} strokeWidth="1.6" />

            <rect x="8.076" y="11.742" width="8.333" height="8.333" rx="1.389" stroke={fill} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />

            <rect x="12.937" y="17.992" width="2.083" height="1.389" rx="0.694" transform="rotate(-90 12.937 17.992)" fill={fill} />

            <rect x="10.159" y="17.992" width="2.083" height="1.389" rx="0.694" transform="rotate(-90 10.16 17.992)" fill={fill} />

            <rect x="11.548" y="13.131" width="1.389" height="1.389" rx="0.347" fill={fill} />

            <rect x="19.187" y="11.742" width="6.25" height="2.083" rx="1.042" stroke={fill} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />

            <rect x="19.187" y="17.298" width="6.25" height="2.778" rx="0.694" stroke={fill} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
export default React.memo(Icon);
